export const BRIDGEPAY_URL = process.env.REACT_APP_BRIDGEPAY_URL;
export const NEW_BASE_URL =
  process.env.REACT_APP_PHP_API_URL + '/api_entry_point/olo/';
export const TOKEN_URL = NEW_BASE_URL + 'gen/token';
export const MERCHANT_DETAILS_URL = NEW_BASE_URL + 'get/locationConfig/';
export const SIGN_IN_URL = NEW_BASE_URL + 'get/userSignin/';
export const REGISTER_URL = NEW_BASE_URL + 'get/userRegistration';
export const LOCATION_ADDRESS_URL = NEW_BASE_URL + 'get/locationAddress/';
export const MEAL_PLAN_ENABLE_URL = NEW_BASE_URL + 'get/MealPlanInfo';
export const DELIVERY_ADDRESS_URL = NEW_BASE_URL + 'get/deliveryAddress/';
export const PICKUP_AND_DINEIN_ADDRESS_URL =
  NEW_BASE_URL + 'get/pickUpDineInLocationAddress/';
export const GIFT_CARD_URL = NEW_BASE_URL + 'get/lavuGiftCardDetails/';
export const LOYALTY_POINTS_URL =
  NEW_BASE_URL + 'get/lavuLoyaltyPointsDetails/';
export const ITEMS_LIST_URL = NEW_BASE_URL + 'get/itemsList/';
export const MY_ACCOUNT_URL = NEW_BASE_URL + 'get/userAccount/';
export const ORDER_HISTROY_URL = NEW_BASE_URL + 'get/orderHistory/';
export const REORDER_URL = NEW_BASE_URL + 'get/reOrder/';
export const ORDER_AS_COD = NEW_BASE_URL + 'get/cod/';
export const ORDER_PAYPAL_WALLET = NEW_BASE_URL + 'get/cardPayment/';
export const ORDER_MEALPLAN = NEW_BASE_URL + 'get/mealPlanPayment/';
export const ADD_TO_CART = NEW_BASE_URL + 'get/itemsTaxDetails/';
export const CHECK_CART_ITEMS = NEW_BASE_URL + 'get/itemInventoryStatus/';
export const GO_TO_CHECKOUT = NEW_BASE_URL + 'get/orderDetails/';
export const GET_MENUS = NEW_BASE_URL + 'get/Menus/';
export const ADD_MEALPLAN_FUNDS = NEW_BASE_URL + 'get/mealPlanAddFunds/';
export const LAVU_TO_GO_LOCATION_ADDRESS =
  NEW_BASE_URL + 'get/lavutogoLocationAddress';
export const RESET_PASSWORD = `${NEW_BASE_URL}get/forgotPassword`;
export const UPDATE_PASSWORD = `${NEW_BASE_URL}get/updatePassword`;
export const ITEM_EXIST = `${NEW_BASE_URL}get/itemExist`;
export const DETOR_MODIFIERS = `${NEW_BASE_URL}get/getDetourDetails`;
export const USER_MEAL_PLAN_SETTINGS = `${NEW_BASE_URL}get/mealPlanDetails`;
export const RESTUARANT_LOCATION_BY_LAVU_TO_GO_NAME = `${NEW_BASE_URL}get/locationAddressByLavutogoName`;
export const LIST_USER_ADRRESS = `${NEW_BASE_URL}get/listUserAddress`;
export const SAVE_USER_ADRRESS = `${NEW_BASE_URL}get/saveAddress`;
export const DELETE_USER_ADRRESS = `${NEW_BASE_URL}get/deleteAddress`;



// WEBPACK FOOTER //
// ./src/util/urls.js